import { useModelEditContext } from '@rhino-project/core/hooks';
import { useGlobalComponentForModel } from '@rhino-project/core/hooks';
import { useRenderPaths } from '../../hooks/renderPaths';
import { ModelFieldGroup } from './ModelFieldGroup';
import { FormErrors } from '../forms/FormErrors';
import { Form } from '@heroui/react';

export interface ModelEditFormProps {
  paths?: string[];
}

export const ModelEditFormBase = (props: ModelEditFormProps) => {
  const { paths } = useModelEditContext();
  const renderPaths = useRenderPaths(props.paths || paths, {
    Component: ModelFieldGroup
  });

  return (
    <Form>
      <FormErrors />
      {renderPaths}
    </Form>
  );
};

export const ModelEditForm = (props: ModelEditFormProps) =>
  useGlobalComponentForModel('ModelEditForm', ModelEditFormBase, props);
